import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import PropTypes from 'prop-types';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import AccountPerformanceChartLegend
  from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/Content/ManagedAccountPageTabPanel/Layouts/AccountPerformanceDashboard/AccountPerformance/AccountPerformanceChartLegend/AccountPerformanceChartLegend';
import AccountPerformanceChart
  from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/Content/ManagedAccountPageTabPanel/Layouts/AccountPerformanceDashboard/AccountPerformance/AccountPerformanceChart';

const useStyles = buildUseStyles('PerformanceChartContainer', ((theme) => ({
  root: {},
  noPerformance: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    width: '100%',
    background: theme.palette.facet.backgroundGray,
    borderRadius: theme.radius.md,
  },
  data: {
    display: 'flex',
    flexWrap: 'wrap',
    flex: 1,
    justifyContent: 'start',
  },
  chart: {
    minHeight: 320,
    flex: `1 1 ${theme.dimensions.lg}px`,
    maxWidth: '100%',
  },
  legend: {
    paddingLeft: theme.spacing(1),
  },
})));

const PerformanceChartContainer = ({ benchmarkedPerformance, toggleShowBenchmark, showBenchmark }) => {
  const classes = useStyles();
  const hasChartDataPoints = benchmarkedPerformance.attr('accountPerformanceChartData').resources().length() > 0;

  if (!hasChartDataPoints) {
    return (
      <Box className={classes.noPerformance}>
        <Text text={'We do not have performance data for the selected date range'} variant={'h3'} color={'black'} />
      </Box>
    );
  }

  return (
    <>
      <AccountPerformanceChartLegend className={classes.legend} toggleShowBenchmark={toggleShowBenchmark} showBenchmark={showBenchmark} />
      <Box className={classes.data}>
        <Box className={classes.chart}>
          <AccountPerformanceChart resource={benchmarkedPerformance} showBenchmark={showBenchmark} />
        </Box>
      </Box>
    </>
  );
};

PerformanceChartContainer.defaultProps = {
};

PerformanceChartContainer.propTypes = {
  benchmarkedPerformance: PropTypes.object.isRequired,
};

export default PerformanceChartContainer;
